function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (theme) {
  return {
    getCSS: function getCSS(_ref) {
      var targetElement = _ref.targetElement,
          fullWidth = _ref.fullWidth,
          disabled = _ref.disabled;

      switch (targetElement) {
        case "fieldContainer":
          {
            return _objectSpread(_objectSpread({
              display: "inline-flex",
              flexDirection: "column",
              position: "relative"
            }, fullWidth && {
              display: "flex",
              width: "100%",
              minWidth: 0 // See: https://stackoverflow.com/a/36247448/247243

            }), disabled && {
              opacity: 0.5
            });
          }

        case "label":
          {
            return {
              display: "flex",
              fontFamily: theme.fonts.body,
              fontSize: theme.fontSizes[1],
              fontWeight: theme.fontWeights.medium,
              lineHeight: theme.lineHeights[2],
              color: theme.colors.grey.t75,
              marginBottom: theme.space[2]
            };
          }

        case "optionalTag":
          {
            return {
              alignSelf: "flex-end",
              fontSize: theme.fontSizes[0],
              lineHeight: theme.lineHeights[0],
              paddingLeft: theme.space[2],
              paddingRight: theme.space[2],
              border: "".concat(theme.borderWidths[1], " solid ").concat(theme.colors.grey.t75),
              borderRadius: theme.radii[2],
              opacity: 0.66,
              marginLeft: "auto"
            };
          }

        case "helpText":
          {
            return {
              paddingTop: theme.space[2]
            };
          }

        case "errorsContainer":
          {
            return {
              paddingTop: theme.space[1],
              borderTop: "".concat(theme.borderWidths[2], " solid ").concat(theme.colors.conditional.negative.graphics),
              zIndex: 1
            };
          }

        default:
          {
            return null;
          }
      }
    }
  };
});